import HttpRequest from './httpRequest'

export default class CustomerTypeProvider extends HttpRequest {
  fetchEmailCreateOrderById (orderId) {
    return this.fetch(`/email/create-order/${orderId}`)
  }
}
